import React from 'react';
import SearchScreen from "../components/Search/SearchScreen";

const Search = () => {
    return (
        <div className="w-screen h-screen flex justify-end items-end">
            <SearchScreen />
        </div>
    );
};

export default Search;